// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__PZc9I","title":"AfterFrontImage_title__1axMF"};